import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";
import { useResource } from "../../../Hooks/UseResource";

export default function OcrExtractResource() {
    const[resourceError, loading, getData, postData, uploadData] =useResource();

   const getOCRExtractFromProof =(accountType,ocrtype,proofFile,suppressSuccessAlert)=>{
    return uploadData( {url:'/ocr-extract',  params:{"appKey": sessionStorage.getItem(SessionKeyEnum.AppKey),
    "accountTypeShortName": accountType,"ocrType":ocrtype}, fileToUpload: proofFile},suppressSuccessAlert);       
 
   }

    return [getOCRExtractFromProof]

}





